/* eslint-disable no-tabs */
import React from 'react';
import PropTypes from 'prop-types';

const CheckIcon = ({ fill, style, ...rest }) => (
  <svg
    {...rest}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 10.539 7.2"
    style={{ enableBackground: 'new 0 0 10.539 7.2', ...style }}
    xmlSpace="preserve"
  >
    <path
      fill={fill}
      d="M10.389,0.143C10.192-0.05,9.876-0.046,9.682,0.15L3.967,5.991L0.85,2.939
	C0.654,2.747,0.337,2.75,0.143,2.947C-0.05,3.144-0.047,3.461,0.151,3.654l3.464,3.392c0.003,0.003,0.004,0.008,0.008,0.012
	C3.72,7.153,3.846,7.2,3.972,7.2c0.13,0,0.259-0.05,0.357-0.15l6.067-6.2C10.59,0.652,10.586,0.336,10.389,0.143z"
    />
  </svg>
);

CheckIcon.propTypes = {
  fill: PropTypes.string.isRequired,
  style: PropTypes.object,
  rest: PropTypes.object,
};

CheckIcon.defaultProps = {
  style: {},
  rest: {},
};

export default CheckIcon;



// WEBPACK FOOTER //
// ./src/assets/CheckIcon.jsx